export default __webpack_public_path__ + "static/media/Acolyte's Jerkin of the Abyss.a2400c29.jpg";